import { jsx } from "react/jsx-runtime";
import QuizIcon from "@mui/icons-material/Quiz";
import { validateTidalLicense } from "../../base/index.js";
function Quiz(props) {
  return /* @__PURE__ */ jsx(
    QuizIcon,
    {
      "data-testid": "Quiz",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Quiz",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
Quiz.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "Quiz"
};
validateTidalLicense();
export {
  Quiz
};
//# sourceMappingURL=Quiz.js.map
